// Stylized, procedurally built figure (no external model). Shared joint map also drives the 2.5D fallback.
export const TORSO_PROFILE = [
  [0, 0.93], [0.12, 0.935], [0.165, 0.97], [0.17, 1.03], [0.152, 1.12], [0.142, 1.2], [0.158, 1.3],
  [0.18, 1.38], [0.185, 1.43], [0.165, 1.47], [0.1, 1.5], [0.04, 1.51], [0, 1.51],
];
export const TORSO_DEPTH = 0.62;

export const LIMBS = [
  { a: [0, 1.47, 0], b: [0, 1.6, -0.005], r: 0.048 },
  ...[-1, 1].flatMap((s) => [
    { a: [0.2 * s, 1.42, 0], b: [0.265 * s, 1.14, 0], r: 0.045 },
    { a: [0.265 * s, 1.14, 0], b: [0.31 * s, 0.88, 0], r: 0.038 },
    { a: [0.09 * s, 0.95, 0], b: [0.1 * s, 0.52, 0], r: 0.075 },
    { a: [0.1 * s, 0.52, 0], b: [0.1 * s, 0.1, 0], r: 0.055 },
    { a: [0.1 * s, 0.045, -0.03], b: [0.1 * s, 0.045, 0.13], r: 0.045 },
  ]),
];

export const BLOBS = [
  { pos: [0, 1.69, 0], scale: [0.09, 0.115, 0.1] },
  ...[-1, 1].flatMap((s) => [
    { pos: [0.19 * s, 1.42, 0], scale: [0.058, 0.058, 0.058] },
    { pos: [0.33 * s, 0.8, 0], scale: [0.042, 0.075, 0.026] },
  ]),
];
